<template>
  <div class="fixed-nav" draggable :style="{top: top + 'px'}" @dragstart="onDragStart" @drag="onDrag">
    <div
      v-for="(item, index) in navItems"
      :key="index"
      v-if="item.visible"
      class="fixed-nav-item"
      :class="itemClass"
      :style="getItemStyle(index)"
      @click="item.onClick && item.onClick()"
      @mouseenter="handleMouseEnter(index)"
      @mouseleave="handleMouseLeave">
      <i class="iconfont" v-html="item.icon" :style="getIconStyle(item, index)"></i>
      <span class="fix-nav-text">{{ item.text }}</span>
      <!-- 弹层 -->
      <div v-if="item.popup" class="fixed-nav-show" :class="item.popup.class">
        <div :class="['show-content', item.popup.contentClass]">
          <!-- 微信咨询 -->
          <template v-if="item.key === 'wx'">
            <img :src="floatingInfoConfig.wechatConfig?.qrCodeImg || wxImgUrl" id="yms_wx"/>
            <span class="font-size-12 mt4 mb4 color-333 ellipsis-text" v-if="floatingInfoConfig.wechatConfig?.consultationTime"
              :title="floatingInfoConfig.wechatConfig.consultationTime" style="max-width: 170px;">
              {{ floatingInfoConfig.wechatConfig.consultationTime }}
            </span>
          </template>
          <!-- 电话咨询 -->
          <template v-else-if="item.key === 'phone'">
            <span class="icon-circle">
              <i class="iconfont">&#xe60f;</i>
            </span>
            <span class="show-qq-num" v-if="floatingInfoConfig.phoneConfig?.phone">
              <div v-if="floatingInfoConfig.phoneConfig?.consultationTime" class="tel-line"
                :title="floatingInfoConfig.phoneConfig.consultationTime">{{ floatingInfoConfig.phoneConfig.consultationTime }}</div>
              <div class="tel-line" :title="floatingInfoConfig.phoneConfig.phone">
                <b>{{ floatingInfoConfig.phoneConfig.phone }}</b>
              </div>
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {checkLogin, isChineseLanguage, pageJump, commonLocalStorage} from "@/utils/common";

export default {
  name: 'fixedRightNav',
  mixins: [Mixin],
  props: {
    source: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      top: 0,
      startY: 0,
      startTop: 0,
      isAlibabaSite: false,
      hoverIndex: null, // 当前 hover 的按钮索引
      wxImgUrl: require('#@/static/images/wx.png'),
      navItems: [
        {
          key: 'shoppingCart',
          icon: '&#xe70b;',
          iconSize: 30,
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000224'),
          visible: true,
          onClick: () => {
            switch (this.source) {
              // 分销商
              case 'distributor':
                pageJump('/index.html#/shoppingCartList', '/yms-shopping-service', '_blank');
                break;

              // 商城
              case 'shopping':
                checkLogin(true).then(() => {
                  const {href} = this.$router.resolve({
                    path: '/shoppingCartList'
                  });
                  window.open(href, '_blank');
                });
                break;

              // 商城--店铺
              case 'shoppingMallStore':
                checkLogin(true).then(() => {
                  pageJump('/index.html#/shoppingCartList', '/yms-shopping-service', '_blank');
                });
                break;
            }
          },
        },
        {
          key: 'wx',
          icon: '&#xe78e;',
          iconSize: 22,
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000225'),
          visible: true,
          popup: {
            class: '',
            contentClass: 'show-content-weixin',
          },
          onClick: null,
        },
        {
          key: 'phone',
          icon: '&#xe60f;',
          iconSize: 24,
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000226'),
          visible: true,
          popup: {
            class: 'fixed-nav-show-tel animated fadeInRight',
            contentClass: 'show-content-tel',
          },
          onClick: null,
        },
        {
          key: 'backTop',
          icon: '&#xe63c;',
          iconSize: 22,
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000227'),
          visible: true,
          popup: null,
          onClick: () => {
            const app = document.querySelector('#app');
            if (!app) return;
            const start = app.scrollTop;
            const duration = 250;
            const startTime = performance.now();

            const scroll = now => {
              const progress = Math.min((now - startTime) / duration, 1);
              const value = start * (1 - progress);
              app.scrollTop = value;
              if (progress < 1) requestAnimationFrame(scroll);
            };
            requestAnimationFrame(scroll);
          },
        },
      ],
    };
  },

  computed: {
    // 获取商城右侧悬浮信息展示配置
    floatingInfoConfig() {
      const config = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return config?.mallRightFloatingInfoConfig || {};
    },
    itemClass() {
      return {
        'alibaba-skin': this.isAlibabaSite
      };
    },
    // 泰瑞森商城、yms商城主题颜色
    shopThemeColor() {
      return this.systemEnvironment === 'trs' ? '#89b92a' : '#FD5425';
    }
  },
  mounted() {
    this.initSiteType();
    this.setInitialPosition();
    window.addEventListener('isAlibabaSiteUpdated', this.initSiteType);
    window.addEventListener('resize', this.setInitialPosition);
    this.updateNavVisibility();
  },
  beforeDestroy() {
    window.removeEventListener('isAlibabaSiteUpdated', this.initSiteType);
    window.removeEventListener('resize', this.setInitialPosition);
  },
  methods: {
    // 初始化站点类型
    initSiteType() {
      const erpConfig = JSON.parse(sessionStorage.getItem('erpConfig') || '{}');
      this.isAlibabaSite = erpConfig && erpConfig.ymsSite && erpConfig.ymsSite.merchantType === 'ALIGJ';
      sessionStorage.setItem('isAlibabaSite', JSON.stringify(this.isAlibabaSite));
      this.updateNavVisibility();
    },
    // 设置浮动菜单初始位置，距离底部 180px
    setInitialPosition() {
      this.$nextTick(() => {
        const navHeight = this.$el.offsetHeight || 272;
        this.top = window.innerHeight - navHeight - 180;
        if (this.top < 0) {
          this.top = 0;
        }
      });
    },
    // 更新浮动按钮显示状态
    updateNavVisibility() {
      const show = isChineseLanguage() && !this.isAlibabaSite;
      const floatingConfig = this.floatingInfoConfig;
      const rules = {
        shoppingCart: this.$route.path !== '/login',
        wx: Number(floatingConfig.wechatConfig?.show) === 1,
        phone: Number(floatingConfig.phoneConfig?.show) === 1,
      };
      this.navItems.forEach(item => {
        if (item.key in rules) {
          item.visible = show && rules[item.key];
        }
      });
    },
    // 鼠标移入
    handleMouseEnter(index) {
      this.hoverIndex = index;
    },
    // 鼠标移出
    handleMouseLeave() {
      this.hoverIndex = null;
    },
    // 每个按钮的动态样式
    getItemStyle(index) {
      const isHover = this.hoverIndex === index;
      // 阿里皮肤优先保留原逻辑
      if (this.isAlibabaSite) {
        return isHover
          ? {
            background: '#2d8cf0',
            color: '#fff',
            borderColor: '#2d8cf0'
          }
          : {};
      }
      // 默认站点使用动态主题色
      return isHover
        ? {
          background: this.shopThemeColor,
          color: '#fff',
          borderColor: this.shopThemeColor
        }
        : {};
    },
    // 图标动态样式
    getIconStyle(item, index) {
      const isHover = this.hoverIndex === index;
      // 阿里国际站 hover 时图标白色，非 hover 使用默认主题色
      if (this.isAlibabaSite) {
        return {
          fontSize: (item.iconSize || 22) + 'px',
          color: isHover ? '#fff' : this.shopThemeColor,
          display: 'inline-block',
          height: '34px'
        };
      }
      return {
        fontSize: (item.iconSize || 22) + 'px',
        color: isHover ? '#fff' : this.shopThemeColor,
        display: 'inline-block',
        height: '34px'
      };
    },
    // 拖拽开始
    onDragStart(e) {
      this.startY = e.clientY;
      this.startTop = this.top;
    },
    // 拖拽中
    onDrag(e) {
      if (!e.clientY) return;
      const nextTop = this.startTop + (e.clientY - this.startY);
      if (nextTop >= 0) {
        this.top = nextTop;
      }
    },
  },
};
</script>

<style lang="less">
.fixed-nav {
  position: fixed;
  right: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.15);
  z-index: 9900;
}

.fixed-nav-item {
  width: 68px;
  height: 68px;
  background: #fff;
  color: #1d1d1d;
  border-bottom: solid 1px #efefef;
  text-align: center;
  padding-top: 8px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s;
}

.fixed-nav-item .iconfont {
  display: inline-block;
  height: 34px;
  font-size: 22px;
}

.fix-nav-text {
  display: block;
  font-size: 12px;
  line-height: 1;
  margin-top: 1px;
}

/* 阿里国际分销皮肤：hover 颜色由行内样式接管，这里保留兼容 class */
.alibaba-skin {
}

/* hover 弹层 */
.fixed-nav-show {
  display: none;
}

.fixed-nav-item:hover .fixed-nav-show {
  display: block;
  position: absolute;
  right: 64px;
  top: 0;
}

/* 弹层内容 */
.show-content {
  padding: 10px;
  text-align: center;
  background: #fff;
  box-shadow: 0 5px 15px 0 rgba(138, 141, 147, 0.4);
  margin-right: 18px;
  position: relative;
}

.show-content:before {
  content: '';
  position: absolute;
  top: 15px;
  right: -16px;
  border: 8px solid transparent;
  border-left: 8px solid #fff;
}

.show-content-weixin {
  padding: 5px;
}

/* 微信二维码 */
#yms_wx {
  width: 170px;
  height: 170px;
  cursor: pointer;
  transition: 0.1s ease-in;
}

/* 电话弹层 */
.show-content-tel {
  width: 240px;
  text-align: left;
  color: #333;
}

.icon-circle {
  display: inline-block;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: #f1f1f3;
  border-radius: 50%;
  margin-right: 8px;
}

.icon-circle .iconfont {
  color: #777 !important;
}

.show-qq-num {
  display: inline-block;
  font-size: 12px;
  line-height: 22px;
  max-width: 160px;
  vertical-align: top;
}

/* 文字溢出省略 */
.ellipsis-text {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 电话弹层每行文本溢出省略 */
.tel-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.show-qq-num b {
  font-size: 20px;
  font-weight: normal;
}
</style>